import React from 'react';
import { Grid } from '@mui/material';

import { AuthorizerContext } from 'app/providers/acl/AclProvider';
import {
	CurrencyTextField,
	DateField,
	LanguageSelectField,
	NumberTextField,
	SearchSelectField,
	SimpleTextField,
	useSettings
} from 'app/main/components';
import { type DetailsSectionInfoContentProps } from 'app/main/components/page-layouts';

export default function UsersDetailsSectionInfo(props: DetailsSectionInfoContentProps) {
	const { t, sysSettings } = useSettings();
	const authorizer = React.useContext(AuthorizerContext);

	const systemInfoAuthorized = authorizer.can('update-systeminfo', 'users');

	if (!props.model.workday_time_tot) {
		props.sendChange('user_workday_time_tot', sysSettings.workday_time_tot);
	}

	return (
		<>
			{/* NAME */}
			<Grid size={{ lg: 3, sm: 6, xs: 12 }}>
				<SimpleTextField
					name="user_name"
					label={t('DETAILS_USERS_FIELD_NAME')}
					value={props.model.user_name}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
					required
					validationError={t('ERROR_TEXT_REQUIRED')}
				/>
			</Grid>
			{/* SURNAME */}
			<Grid size={{ lg: 3, sm: 6, xs: 12 }}>
				<SimpleTextField
					name="user_surname"
					label={t('DETAILS_USERS_FIELD_SURNAME')}
					value={props.model.user_surname}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
					required
					validationError={t('ERROR_TEXT_REQUIRED')}
				/>
			</Grid>
			{/* RECRUITMENT DATE */}
			<Grid size={{ lg: 3, sm: 6, xs: 12 }}>
				<DateField
					name="user_d_recruitment"
					label={t('DETAILS_USERS_FIELD_RECRUITMENT_DATE')}
					value={props.model.user_d_recruitment}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			{/* BIRTHDAY */}
			<Grid size={{ lg: 3, sm: 6, xs: 12 }}>
				<DateField
					name="user_birthday"
					label={t('DETAILS_USERS_FIELD_BIRTHDAY')}
					value={props.model.user_birthday}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			{/* LANGUAGE */}
			<Grid size={{ lg: 3, sm: 6, xs: 12 }}>
				<LanguageSelectField
					name="user_language"
					value={props.model.user_language}
					userUid={props.model.user_uid}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			{/* ERP ID */}
			<Grid size={{ lg: 3, sm: 6, xs: 12 }}>
				<SimpleTextField
					name="user_erp_id"
					label={t('DETAILS_USERS_FIELD_ERP_ID')}
					value={props.model.user_erp_id}
					isEdit={props.isEdit && systemInfoAuthorized}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			{/* ERP SALESPERSON ID */}
			<Grid size={{ lg: 3, sm: 6, xs: 12 }}>
				<SearchSelectField
					name="user_erp_salesperson_id"
					label={t('DETAILS_USERS_FIELD_ERP_SALESPERSON_ID')}
					systable="nav_salesperson"
					value={props.model.user_erp_salesperson_id}
					isEdit={props.isEdit && systemInfoAuthorized}
					getOptionLabel={option => `${option.slpe_id} - ${option.slpe_title}`}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			{/* HOURLY RATE */}
			{/* <Grid size={{ lg: 3, sm: 6, xs: 12 }}>
				<CurrencyTextField
					name="user_hourly_rate"
					label={t('DETAILS_USERS_FIELD_HOURLY_RATE')}
					value={props.model.user_hourly_rate}
					isEdit={props.isEdit && systemInfoAuthorized}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid> */}
			{/* TOTAL WORKDAY HOURS */}
			<Grid size={{ lg: 3, sm: 6, xs: 12 }}>
				<NumberTextField
					name="user_workday_time_tot"
					label={t('SETTINGS_TIME_WORKDAY')}
					step={1}
					measureUnit="h"
					value={props.model.user_workday_time_tot}
					isEdit={props.isEdit}
					required
					sendChange={props.sendChange}
				/>
			</Grid>
			{/* LAYOUT */}
			{/* <Grid size={{ sm: 6, xs: 12 }}>
				<LayoutSelectField
					name="user_layout"
					value={props.model.user_layout}
					userUid={props.model.user_uid}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid> */}
			{/* THEME */}
			{/* <Grid size={{ sm: 6, xs: 12 }}>
				<ThemeSelectField
					name="user_theme"
					value={props.model.user_theme}
					userUid={props.model.user_uid}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid> */}
		</>
	);
}
